module.exports = __webpack_public_path__ + "img/bsilva.5657d272.jpg";